import script from "./AmortisedCost.vue?vue&type=script&setup=true&lang=js"
export * from "./AmortisedCost.vue?vue&type=script&setup=true&lang=js"

import "./AmortisedCost.vue?vue&type=style&index=0&id=e5bdb5f8&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e5bdb5f8"]])

export default __exports__